/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  java_package: "com.pioneer.common.barrage.douyin.protobuf.dto"
})
.addJSON({
  Common: {
    fields: {
      method: {
        type: "string",
        id: 1
      },
      msgId: {
        type: "uint64",
        id: 2
      },
      roomId: {
        type: "uint64",
        id: 3
      },
      createTime: {
        type: "uint64",
        id: 4
      },
      monitor: {
        type: "uint32",
        id: 5
      },
      isShowMsg: {
        type: "bool",
        id: 6
      },
      describe: {
        type: "string",
        id: 7
      },
      foldType: {
        type: "uint64",
        id: 9
      },
      anchorFoldType: {
        type: "uint64",
        id: 10
      },
      priorityScore: {
        type: "uint64",
        id: 11
      },
      logId: {
        type: "string",
        id: 12
      },
      msgProcessFilterK: {
        type: "string",
        id: 13
      },
      msgProcessFilterV: {
        type: "string",
        id: 14
      },
      user: {
        type: "User",
        id: 15
      },
      anchorFoldTypeV2: {
        type: "uint64",
        id: 17
      },
      processAtSeiTimeMs: {
        type: "uint64",
        id: 18
      },
      randomDispatchMs: {
        type: "uint64",
        id: 19
      },
      isDispatch: {
        type: "bool",
        id: 20
      },
      channelId: {
        type: "uint32",
        id: 21
      },
      diffSei2absSecond: {
        type: "uint64",
        id: 22
      },
      anchorFoldDuration: {
        type: "uint64",
        id: 23
      }
    }
  },
  User: {
    fields: {
      id: {
        type: "uint64",
        id: 1
      },
      shortId: {
        type: "uint64",
        id: 2
      },
      nickname: {
        type: "string",
        id: 3
      },
      gender: {
        type: "uint32",
        id: 4
      },
      signature: {
        type: "string",
        id: 5
      },
      level: {
        type: "uint32",
        id: 6
      },
      birthday: {
        type: "uint64",
        id: 7
      },
      telephone: {
        type: "string",
        id: 8
      },
      avatarThumb: {
        type: "Image",
        id: 9
      },
      avatarMedium: {
        type: "Image",
        id: 10
      },
      avatarLarge: {
        type: "Image",
        id: 11
      },
      verified: {
        type: "bool",
        id: 12
      },
      experience: {
        type: "int32",
        id: 13
      },
      city: {
        type: "string",
        id: 14
      },
      status: {
        type: "int32",
        id: 15
      },
      createTime: {
        type: "int64",
        id: 16
      },
      modifyTime: {
        type: "int64",
        id: 17
      },
      secret: {
        type: "int32",
        id: 18
      },
      shareQrcodeUri: {
        type: "string",
        id: 19
      },
      incomeSharePercent: {
        type: "int32",
        id: 20
      },
      badgeImageListList: {
        type: "Image",
        id: 21
      },
      followInfo: {
        type: "FollowInfo",
        id: 22
      },
      payGrade: {
        type: "PayGrade",
        id: 23
      },
      fansClub: {
        type: "FansClub",
        id: 24
      },
      border: {
        type: "Border",
        id: 25
      },
      specialId: {
        type: "string",
        id: 26
      },
      avatarBorder: {
        type: "Image",
        id: 27
      },
      medal: {
        type: "Image",
        id: 28
      },
      realTimeIconsList: {
        rule: "repeated",
        type: "Image",
        id: 29
      },
      newRealTimeIconsList: {
        rule: "repeated",
        type: "Image",
        id: 30
      },
      topVipNo: {
        type: "int64",
        id: 31
      },
      userAttr: {
        type: "UserAttr",
        id: 32
      },
      ownRoom: {
        type: "OwnRoom",
        id: 33
      },
      payScore: {
        type: "int64",
        id: 34
      },
      ticketCount: {
        type: "int64",
        id: 35
      },
      anchorInfo: {
        type: "AnchorInfo",
        id: 36
      },
      linkMicStats: {
        type: "int32",
        id: 37
      },
      displayId: {
        type: "string",
        id: 38
      },
      withCommercePermission: {
        type: "bool",
        id: 39
      },
      withFusionShopEntry: {
        type: "bool",
        id: 40
      },
      totalRechargeDiamondCount: {
        type: "int64",
        id: 41
      },
      webcastAnchorLevel: {
        type: "AnchorLevel",
        id: 42
      },
      verifiedContent: {
        type: "string",
        id: 43
      },
      authorStats: {
        type: "AuthorStats",
        id: 44
      },
      topFansList: {
        rule: "repeated",
        type: "User",
        id: 45
      },
      secUid: {
        type: "string",
        id: 46
      },
      userRole: {
        type: "int32",
        id: 47
      },
      xiguaInfo: {
        type: "XiguaParams",
        id: 48
      },
      activityReward: {
        type: "ActivityInfo",
        id: 49
      },
      nobleInfo: {
        type: "NobleLevelInfo",
        id: 50
      },
      brotherhoodInfo: {
        type: "BrotherhoodInfo",
        id: 51
      },
      personalCard: {
        type: "Image",
        id: 52
      },
      authenticationInfo: {
        type: "AuthenticationInfo",
        id: 53
      },
      authorizationInfo: {
        type: "int32",
        id: 54
      },
      adversaryAuthorizationInfo: {
        type: "int32",
        id: 55
      },
      poiInfo: {
        type: "PoiInfo",
        id: 56
      },
      mediaBadgeImageListList: {
        type: "Image",
        id: 57
      },
      adversaryUserStatus: {
        type: "int32",
        id: 58
      },
      userVipInfo: {
        type: "UserVIPInfo",
        id: 59
      },
      commerceWebcastConfigIdsList: {
        rule: "repeated",
        type: "int64",
        id: 60
      },
      badgeImageListV2List: {
        type: "Image",
        id: 61
      },
      locationCity: {
        type: "string",
        id: 63
      },
      fansGroupInfo: {
        type: "FansGroupInfo",
        id: 64
      },
      remarkName: {
        type: "string",
        id: 65
      },
      mysteryMan: {
        type: "int32",
        id: 66
      },
      webRid: {
        type: "string",
        id: 67
      },
      desensitizedNickname: {
        type: "string",
        id: 68
      },
      jAccreditInfo: {
        type: "JAccreditInfo",
        id: 69
      },
      subscribe: {
        type: "Subscribe",
        id: 70
      },
      isAnonymous: {
        type: "bool",
        id: 71
      },
      consumeDiamondLevel: {
        type: "int32",
        id: 72
      },
      webcastUid: {
        type: "string",
        id: 73
      },
      profileStyleParams: {
        type: "ProfileStyleParams",
        id: 74
      },
      userDressInfo: {
        type: "UserDressInfo",
        id: 75
      },
      allowBeLocated: {
        type: "bool",
        id: 1001
      },
      allowFindByContacts: {
        type: "bool",
        id: 1002
      },
      allowOthersDownloadVideo: {
        type: "bool",
        id: 1003
      },
      allowOthersDownloadWhenSharingVideo: {
        type: "bool",
        id: 1004
      },
      allowShareShowProfile: {
        type: "bool",
        id: 1005
      },
      allowShowInGossip: {
        type: "bool",
        id: 1006
      },
      allowShowMyAction: {
        type: "bool",
        id: 1007
      },
      allowStrangeComment: {
        type: "bool",
        id: 1008
      },
      allowUnfollowerComment: {
        type: "bool",
        id: 1009
      },
      allowUseLinkmic: {
        type: "bool",
        id: 1010
      },
      anchorLevel: {
        type: "AnchorLevel",
        id: 1011
      },
      avatarJpg: {
        type: "Image",
        id: 1012
      },
      bgImgUrl: {
        type: "string",
        id: 1013
      },
      birthdayDescription: {
        type: "string",
        id: 1014
      },
      birthdayValid: {
        type: "bool",
        id: 1015
      },
      blockStatus: {
        type: "int32",
        id: 1016
      },
      commentRestrict: {
        type: "int32",
        id: 1017
      },
      constellation: {
        type: "string",
        id: 1018
      },
      disableIchat: {
        type: "int32",
        id: 1019
      },
      enableIchatImg: {
        type: "int64",
        id: 1020
      },
      exp: {
        type: "int32",
        id: 1021
      },
      fanTicketCount: {
        type: "int64",
        id: 1022
      },
      foldStrangerChat: {
        type: "bool",
        id: 1023
      },
      followStatus: {
        type: "int64",
        id: 1024
      },
      hotsoonVerified: {
        type: "bool",
        id: 1025
      },
      hotsoonVerifiedReason: {
        type: "string",
        id: 1026
      },
      ichatRestrictType: {
        type: "int32",
        id: 1027
      },
      idStr: {
        type: "string",
        id: 1028
      },
      isFollower: {
        type: "bool",
        id: 1029
      },
      isFollowing: {
        type: "bool",
        id: 1030
      },
      needProfileGuide: {
        type: "bool",
        id: 1031
      },
      payScores: {
        type: "int64",
        id: 1032
      },
      pushCommentStatus: {
        type: "bool",
        id: 1033
      },
      pushDigg: {
        type: "bool",
        id: 1034
      },
      pushFollow: {
        type: "bool",
        id: 1035
      },
      pushFriendAction: {
        type: "bool",
        id: 1036
      },
      pushIchat: {
        type: "bool",
        id: 1037
      },
      pushStatus: {
        type: "bool",
        id: 1038
      },
      pushVideoPost: {
        type: "bool",
        id: 1039
      },
      pushVideoRecommend: {
        type: "bool",
        id: 1040
      },
      stats: {
        type: "UserStats",
        id: 1041
      },
      verifiedMobile: {
        type: "bool",
        id: 1042
      },
      verifiedReason: {
        type: "string",
        id: 1043
      },
      withCarManagementPermission: {
        type: "bool",
        id: 1044
      },
      ageRange: {
        type: "int32",
        id: 1045
      },
      watchDurationMonth: {
        type: "int64",
        id: 1046
      }
    },
    nested: {
      ActivityInfo: {
        fields: {}
      },
      AnchorInfo: {
        fields: {}
      },
      AnchorLevel: {
        fields: {}
      },
      AuthenticationInfo: {
        fields: {}
      },
      AuthorStats: {
        fields: {}
      },
      Border: {
        fields: {}
      },
      BrotherhoodInfo: {
        fields: {}
      },
      FansClub: {
        fields: {
          data: {
            type: "FansClubData",
            id: 1
          },
          preferData: {
            keyType: "int32",
            type: "FansClubData",
            id: 2
          }
        },
        nested: {
          FansClubData: {
            fields: {
              clubName: {
                type: "string",
                id: 1
              },
              level: {
                type: "int32",
                id: 2
              },
              userFansClubStatus: {
                type: "int32",
                id: 3
              },
              badge: {
                type: "UserBadge",
                id: 4
              },
              availableGiftIds: {
                rule: "repeated",
                type: "int64",
                id: 5
              },
              anchorId: {
                type: "int64",
                id: 6
              }
            },
            nested: {
              UserBadge: {
                fields: {
                  icons: {
                    keyType: "int32",
                    type: "Image",
                    id: 1
                  },
                  title: {
                    type: "string",
                    id: 2
                  }
                }
              }
            }
          }
        }
      },
      FansGroupInfo: {
        fields: {}
      },
      FollowInfo: {
        fields: {
          followingCount: {
            type: "int64",
            id: 1
          },
          followerCount: {
            type: "int64",
            id: 2
          },
          followStatus: {
            type: "int64",
            id: 3
          },
          pushStatus: {
            type: "int64",
            id: 4
          },
          remarkName: {
            type: "string",
            id: 5
          }
        }
      },
      JAccreditInfo: {
        fields: {}
      },
      NobleLevelInfo: {
        fields: {}
      },
      OwnRoom: {
        fields: {}
      },
      PayGrade: {
        fields: {
          totalDiamondCount: {
            type: "int64",
            id: 1
          },
          diamondIcon: {
            type: "Image",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          icon: {
            type: "Image",
            id: 4
          },
          nextName: {
            type: "string",
            id: 5
          },
          level: {
            type: "int64",
            id: 6
          },
          nextIcon: {
            type: "Image",
            id: 7
          },
          nextDiamond: {
            type: "int64",
            id: 8
          },
          nowDiamond: {
            type: "int64",
            id: 9
          },
          thisGradeMinDiamond: {
            type: "int64",
            id: 10
          },
          thisGradeMaxDiamond: {
            type: "int64",
            id: 11
          },
          payDiamondBak: {
            type: "int64",
            id: 12
          },
          gradeDescribe: {
            type: "string",
            id: 13
          },
          gradeIconList: {
            rule: "repeated",
            type: "GradeIcon",
            id: 14
          },
          screenChatType: {
            type: "int64",
            id: 15
          },
          imIcon: {
            type: "Image",
            id: 16
          },
          imIconWithLevel: {
            type: "Image",
            id: 17
          },
          liveIcon: {
            type: "Image",
            id: 18
          },
          newImIconWithLevel: {
            type: "Image",
            id: 19
          },
          newLiveIcon: {
            type: "Image",
            id: 20
          },
          upgradeNeedConsume: {
            type: "int64",
            id: 21
          },
          nextPrivileges: {
            type: "string",
            id: 22
          },
          background: {
            type: "Image",
            id: 23
          },
          backgroundBack: {
            type: "Image",
            id: 24
          },
          score: {
            type: "int64",
            id: 25
          },
          gradeBanner: {
            type: "string",
            id: 1001
          },
          profileDialogBg: {
            type: "Image",
            id: 1002
          },
          profileDialogBgBack: {
            type: "Image",
            id: 1003
          }
        },
        nested: {
          GradeIcon: {
            fields: {
              icon: {
                type: "Image",
                id: 1
              },
              iconDiamond: {
                type: "int64",
                id: 2
              },
              level: {
                type: "int64",
                id: 3
              },
              levelStr: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      PoiInfo: {
        fields: {}
      },
      ProfileStyleParams: {
        fields: {}
      },
      Subscribe: {
        fields: {}
      },
      UserAttr: {
        fields: {}
      },
      UserDressInfo: {
        fields: {}
      },
      UserVIPInfo: {
        fields: {}
      },
      UserStats: {
        fields: {}
      },
      XiguaParams: {
        fields: {}
      }
    }
  },
  Image: {
    fields: {
      urlListList: {
        rule: "repeated",
        type: "string",
        id: 1
      },
      uri: {
        type: "string",
        id: 2
      },
      height: {
        type: "int64",
        id: 3
      },
      width: {
        type: "int64",
        id: 4
      },
      avgColor: {
        type: "string",
        id: 5
      },
      imageType: {
        type: "int32",
        id: 6
      },
      openWebUrl: {
        type: "string",
        id: 7
      },
      content: {
        type: "Content",
        id: 8
      },
      isAnimated: {
        type: "bool",
        id: 9
      },
      flexSettingListList: {
        rule: "repeated",
        type: "NinePatchSetting",
        id: 10
      },
      textSettingListList: {
        rule: "repeated",
        type: "NinePatchSetting",
        id: 11
      }
    },
    nested: {
      Content: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          fontColor: {
            type: "string",
            id: 2
          },
          level: {
            type: "int64",
            id: 3
          },
          alternativeText: {
            type: "string",
            id: 4
          }
        }
      },
      NinePatchSetting: {
        fields: {}
      }
    }
  },
  DoubleLikeDetail: {
    fields: {
      doubleFlag: {
        type: "bool",
        id: 1
      },
      seqId: {
        type: "uint32",
        id: 2
      },
      renewalsNum: {
        type: "uint32",
        id: 3
      },
      triggersNum: {
        type: "uint32",
        id: 4
      }
    }
  },
  com: {
    nested: {
      pioneer: {
        nested: {
          common: {
            nested: {
              barrage: {
                nested: {
                  douyin: {
                    nested: {
                      protobuf: {
                        options: {
                          java_package: "com.pioneer.common.barrage.douyin.protobuf",
                          java_outer_classname: "Douyin_websocket_frameProto",
                          java_multiple_files: true,
                          objc_class_prefix: "GPB"
                        },
                        nested: {
                          douyin_cmd_msg: {
                            fields: {
                              method: {
                                type: "string",
                                id: 1
                              },
                              payload: {
                                type: "bytes",
                                id: 2
                              },
                              msgId: {
                                type: "int64",
                                id: 3
                              },
                              msgType: {
                                type: "int32",
                                id: 4
                              },
                              offset: {
                                type: "int64",
                                id: 5
                              },
                              needWrdsStore: {
                                type: "bool",
                                id: 6
                              },
                              wrdsVersion: {
                                type: "int64",
                                id: 7
                              },
                              wrdsSubKey: {
                                type: "string",
                                id: 8
                              }
                            }
                          },
                          douyin_webcast_chat_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              user: {
                                type: "User",
                                id: 2
                              },
                              content: {
                                type: "string",
                                id: 3
                              },
                              visibleToSender: {
                                type: "bool",
                                id: 4
                              },
                              backgroundImage: {
                                type: "Image",
                                id: 5
                              },
                              fullScreenTextColor: {
                                type: "string",
                                id: 6
                              },
                              backgroundImageV2: {
                                type: "Image",
                                id: 7
                              },
                              giftImage: {
                                type: "Image",
                                id: 10
                              },
                              agreeMsgId: {
                                type: "uint64",
                                id: 11
                              },
                              priorityLevel: {
                                type: "uint32",
                                id: 12
                              },
                              eventTime: {
                                type: "uint64",
                                id: 15
                              },
                              sendReview: {
                                type: "bool",
                                id: 16
                              },
                              fromIntercom: {
                                type: "bool",
                                id: 17
                              },
                              intercomHideUserCard: {
                                type: "bool",
                                id: 18
                              },
                              chatBy: {
                                type: "string",
                                id: 20
                              },
                              individualChatPriority: {
                                type: "uint32",
                                id: 21
                              }
                            }
                          },
                          douyin_webcast_control_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              status: {
                                type: "int32",
                                id: 2
                              }
                            }
                          },
                          douyin_webcast_gift_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              longGiftId: {
                                type: "uint64",
                                id: 2
                              },
                              fanTicketCount: {
                                type: "uint64",
                                id: 3
                              },
                              groupCount: {
                                type: "uint64",
                                id: 4
                              },
                              repeatCount: {
                                type: "uint64",
                                id: 5
                              },
                              comboCount: {
                                type: "uint64",
                                id: 6
                              },
                              user: {
                                type: "User",
                                id: 7
                              },
                              toUser: {
                                type: "User",
                                id: 8
                              },
                              repeatEnd: {
                                type: "uint32",
                                id: 9
                              },
                              textEffect: {
                                type: "TextEffect",
                                id: 10
                              },
                              groupId: {
                                type: "uint64",
                                id: 11
                              },
                              incomeTaskgifts: {
                                type: "uint64",
                                id: 12
                              },
                              roomFanTicketCount: {
                                type: "uint64",
                                id: 13
                              },
                              priority: {
                                type: "GiftIMPriority",
                                id: 14
                              },
                              gift: {
                                type: "GiftStruct",
                                id: 15
                              },
                              logId: {
                                type: "string",
                                id: 16
                              },
                              sendType: {
                                type: "uint64",
                                id: 17
                              },
                              publicAreaCommon: {
                                type: "PublicAreaCommon",
                                id: 18
                              },
                              trayDisplayText: {
                                type: "Text",
                                id: 19
                              },
                              bannedDisplayEffects: {
                                type: "uint64",
                                id: 20
                              },
                              displayForSelf: {
                                type: "bool",
                                id: 25
                              },
                              interactGiftInfo: {
                                type: "string",
                                id: 26
                              },
                              diyItemInfo: {
                                type: "string",
                                id: 27
                              },
                              minAssetSetList: {
                                rule: "repeated",
                                type: "uint64",
                                id: 28
                              },
                              totalCount: {
                                type: "uint64",
                                id: 29
                              },
                              clientGiftSource: {
                                type: "uint32",
                                id: 30
                              },
                              toUserIdsList: {
                                rule: "repeated",
                                type: "uint64",
                                id: 32
                              },
                              sendTimet: {
                                type: "uint64",
                                id: 33
                              },
                              forceDisplayEffectst: {
                                type: "uint64",
                                id: 34
                              },
                              traceId: {
                                type: "string",
                                id: 35
                              },
                              effectDisplayTs: {
                                type: "uint64",
                                id: 36
                              }
                            }
                          },
                          douyin_webcast_like_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              count: {
                                type: "uint64",
                                id: 2
                              },
                              total: {
                                type: "uint64",
                                id: 3
                              },
                              color: {
                                type: "uint64",
                                id: 4
                              },
                              user: {
                                type: "User",
                                id: 5
                              },
                              icon: {
                                type: "string",
                                id: 6
                              },
                              doubleLikeDetail: {
                                type: "DoubleLikeDetail",
                                id: 7
                              },
                              linkmicGuestUid: {
                                type: "uint64",
                                id: 9
                              },
                              scene: {
                                type: "string",
                                id: 10
                              }
                            }
                          },
                          douyin_webcast_member_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              user: {
                                type: "User",
                                id: 2
                              },
                              memberCount: {
                                type: "uint64",
                                id: 3
                              },
                              operator: {
                                type: "User",
                                id: 4
                              },
                              isSetToAdmin: {
                                type: "bool",
                                id: 5
                              },
                              isTopUser: {
                                type: "bool",
                                id: 6
                              },
                              rankScore: {
                                type: "int64",
                                id: 7
                              },
                              topUserNo: {
                                type: "int64",
                                id: 8
                              },
                              enterType: {
                                type: "int64",
                                id: 9
                              },
                              action: {
                                type: "int64",
                                id: 10
                              },
                              actionDescription: {
                                type: "string",
                                id: 11
                              },
                              userId: {
                                type: "int64",
                                id: 12
                              },
                              popStr: {
                                type: "string",
                                id: 14
                              },
                              backgroundImage: {
                                type: "Image",
                                id: 16
                              },
                              backgroundImageV2: {
                                type: "Image",
                                id: 17
                              },
                              anchorDisplayText: {
                                type: "Text",
                                id: 18
                              },
                              userEnterTipType: {
                                type: "int64",
                                id: 20
                              },
                              anchorEnterTipType: {
                                type: "int64",
                                id: 21
                              },
                              buriedPointMap: {
                                keyType: "string",
                                type: "string",
                                id: 22
                              }
                            }
                          },
                          douyin_webcast_room_stats_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              displayShort: {
                                type: "string",
                                id: 2
                              },
                              displayMiddle: {
                                type: "string",
                                id: 3
                              },
                              displayLong: {
                                type: "string",
                                id: 4
                              },
                              displayValue: {
                                type: "int64",
                                id: 5
                              },
                              displayVersion: {
                                type: "int64",
                                id: 6
                              },
                              incremental: {
                                type: "bool",
                                id: 7
                              },
                              isHidden: {
                                type: "bool",
                                id: 8
                              },
                              total: {
                                type: "int64",
                                id: 9
                              },
                              displayType: {
                                type: "int64",
                                id: 10
                              }
                            }
                          },
                          douyin_webcast_social_message_msg: {
                            fields: {
                              common: {
                                type: "Common",
                                id: 1
                              },
                              user: {
                                type: "User",
                                id: 2
                              },
                              shareType: {
                                type: "int64",
                                id: 3
                              },
                              action: {
                                type: "int64",
                                id: 4
                              },
                              shareTarget: {
                                type: "string",
                                id: 5
                              },
                              followCount: {
                                type: "int64",
                                id: 6
                              },
                              publicAreaCommon: {
                                type: "PublicAreaCommon",
                                id: 7
                              }
                            }
                          },
                          douyin_websocket_frame_msg: {
                            fields: {
                              messagesList: {
                                rule: "repeated",
                                type: "douyin_cmd_msg",
                                id: 1
                              },
                              cursor: {
                                type: "string",
                                id: 2
                              },
                              fetchInterval: {
                                type: "uint64",
                                id: 3
                              },
                              now: {
                                type: "uint64",
                                id: 4
                              },
                              internalExt: {
                                type: "string",
                                id: 5
                              },
                              fetchType: {
                                type: "uint32",
                                id: 6
                              },
                              routeParams: {
                                keyType: "string",
                                type: "string",
                                id: 7
                              },
                              heartbeatDuration: {
                                type: "uint64",
                                id: 8
                              },
                              needAck: {
                                type: "bool",
                                id: 9
                              },
                              pushServer: {
                                type: "string",
                                id: 10
                              },
                              liveCursor: {
                                type: "string",
                                id: 11
                              },
                              historyNoMore: {
                                type: "bool",
                                id: 12
                              }
                            }
                          },
                          douyin_websocket_frame: {
                            fields: {
                              seqId: {
                                type: "uint64",
                                id: 1
                              },
                              logId: {
                                type: "uint64",
                                id: 2
                              },
                              service: {
                                type: "uint64",
                                id: 3
                              },
                              method: {
                                type: "uint64",
                                id: 4
                              },
                              headersList: {
                                keyType: "string",
                                type: "string",
                                id: 5
                              },
                              payloadEncoding: {
                                type: "string",
                                id: 6
                              },
                              payloadType: {
                                type: "string",
                                id: 7
                              },
                              payload: {
                                type: "bytes",
                                id: 8
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  TextEffect: {
    fields: {
      portrait: {
        type: "TextEffectDetail",
        id: 1
      },
      landscape: {
        type: "TextEffectDetail",
        id: 2
      }
    }
  },
  TextEffectDetail: {
    fields: {
      text: {
        type: "Text",
        id: 1
      },
      textFontSize: {
        type: "uint32",
        id: 2
      },
      background: {
        type: "Image",
        id: 3
      },
      start: {
        type: "uint32",
        id: 4
      },
      duration: {
        type: "uint32",
        id: 5
      },
      x: {
        type: "uint32",
        id: 6
      },
      y: {
        type: "uint32",
        id: 7
      },
      width: {
        type: "uint32",
        id: 8
      },
      height: {
        type: "uint32",
        id: 9
      },
      shadowDx: {
        type: "uint32",
        id: 10
      },
      shadowDy: {
        type: "uint32",
        id: 11
      },
      shadowRadius: {
        type: "uint32",
        id: 12
      },
      shadowColor: {
        type: "string",
        id: 13
      },
      strokeColor: {
        type: "string",
        id: 14
      },
      strokeWidth: {
        type: "uint32",
        id: 15
      }
    }
  },
  Text: {
    fields: {
      key: {
        type: "string",
        id: 1
      },
      defaultPatter: {
        type: "string",
        id: 2
      },
      defaultFormat: {
        type: "TextFormat",
        id: 3
      },
      piecesList: {
        type: "TextPiece",
        id: 4
      }
    }
  },
  TextFormat: {
    fields: {
      color: {
        type: "string",
        id: 1
      },
      bold: {
        type: "bool",
        id: 2
      },
      italic: {
        type: "bool",
        id: 3
      },
      weight: {
        type: "uint32",
        id: 4
      },
      italicAngle: {
        type: "uint32",
        id: 5
      },
      fontSize: {
        type: "uint32",
        id: 6
      },
      useHeighLightColor: {
        type: "bool",
        id: 7
      },
      useRemoteClor: {
        type: "bool",
        id: 8
      }
    }
  },
  TextPiece: {
    fields: {
      type: {
        type: "bool",
        id: 1
      },
      format: {
        type: "TextFormat",
        id: 2
      },
      stringValue: {
        type: "string",
        id: 3
      },
      userValue: {
        type: "TextPieceUser",
        id: 4
      },
      giftValue: {
        type: "TextPieceGift",
        id: 5
      },
      heartValue: {
        type: "TextPieceHeart",
        id: 6
      },
      patternRefValue: {
        type: "TextPiecePatternRef",
        id: 7
      },
      imageValue: {
        type: "TextPieceImage",
        id: 8
      }
    }
  },
  TextPieceImage: {
    fields: {
      image: {
        type: "Image",
        id: 1
      },
      scalingRate: {
        type: "float",
        id: 2
      }
    }
  },
  TextPiecePatternRef: {
    fields: {
      key: {
        type: "string",
        id: 1
      },
      defaultPattern: {
        type: "string",
        id: 2
      }
    }
  },
  TextPieceHeart: {
    fields: {
      color: {
        type: "string",
        id: 1
      }
    }
  },
  TextPieceGift: {
    fields: {
      giftId: {
        type: "uint64",
        id: 1
      },
      nameRef: {
        type: "PatternRef",
        id: 2
      }
    }
  },
  PatternRef: {
    fields: {
      key: {
        type: "string",
        id: 1
      },
      defaultPattern: {
        type: "string",
        id: 2
      }
    }
  },
  TextPieceUser: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      withColon: {
        type: "bool",
        id: 2
      }
    }
  },
  GiftIMPriority: {
    fields: {
      queueSizesList: {
        rule: "repeated",
        type: "uint64",
        id: 1
      },
      selfQueuePriority: {
        type: "uint64",
        id: 2
      },
      priority: {
        type: "uint64",
        id: 3
      }
    }
  },
  GiftStruct: {
    fields: {
      image: {
        type: "Image",
        id: 1
      },
      describe: {
        type: "string",
        id: 2
      },
      notify: {
        type: "bool",
        id: 3
      },
      duration: {
        type: "uint64",
        id: 4
      },
      id: {
        type: "uint64",
        id: 5
      },
      forLinkmic: {
        type: "bool",
        id: 7
      },
      doodle: {
        type: "bool",
        id: 8
      },
      forFansclub: {
        type: "bool",
        id: 9
      },
      combo: {
        type: "bool",
        id: 10
      },
      type: {
        type: "uint32",
        id: 11
      },
      diamondCount: {
        type: "uint32",
        id: 12
      },
      isDisplayedOnPanel: {
        type: "bool",
        id: 13
      },
      primaryEffectId: {
        type: "uint64",
        id: 14
      },
      giftLabelIcon: {
        type: "Image",
        id: 15
      },
      name: {
        type: "string",
        id: 16
      },
      region: {
        type: "string",
        id: 17
      },
      manual: {
        type: "string",
        id: 18
      },
      forCustom: {
        type: "bool",
        id: 19
      },
      specialEffectsMap: {
        keyType: "string",
        type: "int64",
        id: 20
      },
      icon: {
        type: "Image",
        id: 21
      },
      actionType: {
        type: "uint32",
        id: 22
      },
      watermelonSeeds: {
        type: "int32",
        id: 23
      },
      goldEffect: {
        type: "string",
        id: 24
      },
      goldenBeans: {
        type: "int64",
        id: 26
      },
      honorLevel: {
        type: "int64",
        id: 27
      },
      itemType: {
        type: "int32",
        id: 28
      },
      schemeUrl: {
        type: "string",
        id: 29
      },
      eventName: {
        type: "string",
        id: 31
      },
      nobleLevel: {
        type: "int64",
        id: 32
      },
      guideUrl: {
        type: "string",
        id: 33
      },
      punishMedicine: {
        type: "bool",
        id: 34
      },
      forPortal: {
        type: "bool",
        id: 35
      },
      businessText: {
        type: "string",
        id: 36
      },
      cnyGift: {
        type: "bool",
        id: 37
      },
      appId: {
        type: "int64",
        id: 38
      },
      vipLevel: {
        type: "int64",
        id: 39
      },
      isGray: {
        type: "bool",
        id: 40
      },
      graySchemeUrl: {
        type: "string",
        id: 41
      },
      giftScene: {
        type: "int64",
        id: 42
      },
      triggerWords: {
        rule: "repeated",
        type: "string",
        id: 44
      },
      forFirstRecharge: {
        type: "bool",
        id: 46
      },
      dynamicImgForSelected: {
        type: "Image",
        id: 47
      },
      afterSendAction: {
        type: "int32",
        id: 48
      },
      giftOfflineTime: {
        type: "int64",
        id: 49
      },
      topBarText: {
        type: "string",
        id: 50
      },
      topRightAvatar: {
        type: "Image",
        id: 51
      },
      bannerSchemeUrl: {
        type: "string",
        id: 52
      },
      isLocked: {
        type: "bool",
        id: 53
      },
      reqExtraType: {
        type: "int64",
        id: 54
      },
      assetIds: {
        rule: "repeated",
        type: "int64",
        id: 55
      },
      needSweepLightCount: {
        type: "int32",
        id: 58
      }
    }
  },
  PublicAreaCommon: {
    fields: {
      userLabel: {
        type: "Image",
        id: 1
      },
      userConsumeInRoom: {
        type: "uint64",
        id: 2
      },
      userSendGiftCntInRoom: {
        type: "uint64",
        id: 3
      }
    }
  }
});

module.exports = $root;
